/* ログイン(職員) */
import React, { useState, useEffect, useCallback } from 'react';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import PasswordExpiredDialog from '../molecules/PasswordExpiredDialog';
import ResponseDialog from '../molecules/ResponseDialog';
import { createRoot } from 'react-dom/client';

const StaffLogin: React.FC = () => {
  // ログイン情報のState
  const [password, setPassword] = useState('');
  const [login_id, setLoginId] = useState('');
  const [login_error_message, setLoginResult] = useState();
  const [is_loading, setIsLoading] = useState(false);
  const [is_connecting, setIsConnecting] = useState(false);
  // Note sakuma ログインエラーメッセージとは別にstateを持つ
  const [token_mimatch_message, setTokenMimatchMessage] = useState('');
  // ダイアログのState
  const [show, setShow] = useState(false);
  const [show_error_dialog, setShowErrorDialog] = useState(false);

  // エラーメッセージ
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
  }, []);
  // ログインボタンのクリックイベントを定義
  const handleClick = () => {
    // ログイン情報をStateへセット
    const login_info = { loginId: login_id, password: password };
    const login = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);
        const response = await axios.post('/login', login_info);
        // ログイン成功
        if (typeof response.data.debug_user_flg !== 'undefined') {
          // デバッグユーザーログインのためデバッグ画面へ遷移
          location.href = `${location.origin}${process.env.MIX_MOCK_URL}/debug`;
        } else {
          // 職員ユーザーログインのためテンプレート一覧へ遷移
          location.href = `${location.origin}${process.env.MIX_MOCK_URL}/templates/list`;
        }

        setIsConnecting(false);
      } catch (error) {
        // トークン有効期限切れ
        if (error.response.data.is_token_mismatch) {
          setTokenMimatchMessage(error.response.data.message);
          setShowErrorDialog(error.response.data.is_token_mismatch);
        } else {
          setLoginResult(error.response.data.message);
          setIsConnecting(false);
          // パスワードの有効期限切れ判定
          if (
            typeof error.response.data.password_expired !== 'undefined' &&
            error.response.data.password_expired
          ) {
            // パスワード期限切れ
            // ダイアログを表示
            setShow(true);
          }
        }
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    // ログイン処理
    login();
  };
  // パスワード有効期限切れダイアログでOKをクリックしたらパスワード変更画面へ遷移
  const handleClickOk = () => {
    setShow(false);
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/password/change`);
  };

  /**
   * モーダルを非表示にし、画面をリロードする
   */
  const reload = useCallback(() => {
    setShowErrorDialog(false);
    location.reload();
  }, []);

  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="ログイン"
        content={
          <>
            <div className="mx-2">
              <Annotation text="ログインIDとパスワードを入力してください。" />
            </div>
            <div className="mt-3"></div>
            <div>
              <Text
                id="email"
                label="ログインID"
                value={login_id}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setLoginId(event.target.value)
                }
                disabled={false}
                maxlength={200}
              />
              <Text
                id="password"
                label="パスワード"
                type="password"
                value={password}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setPassword(event.target.value)
                }
                disabled={false}
                maxlength={200}
              />
              {login_error_message !== undefined ? (
                <Row className="d-flex align-items-center justify-content-center">
                  <Col></Col>
                  <Col md={9} className="alert-danger alert-danger-custom">
                    {login_error_message}
                  </Col>
                </Row>
              ) : null}
            </div>
          </>
        }
      />
      <div className="mt-5" />
      <CenterButton label="ログイン" handleClick={handleClick} />
      <div className="mt-3" />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
      {/* ダイアログ */}
      <PasswordExpiredDialog okCallback={handleClickOk} open={show} />
      {/* 有効期限切れダイアログ */}
      <ResponseDialog
        is_confirm={true}
        title="有効期限切れ"
        body={token_mimatch_message}
        show={show_error_dialog}
        ClickCallBackConfirm={reload}
      />
    </>
  );
};
const container = document.getElementById('staff-login');
if (container) {
  const root = createRoot(container);
  root.render(<StaffLogin />);
}
